//jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\BooksCollectionEditScreen.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetBooksCollectionDetailsByIdQuery,
  useUpdateBooksCollectionMutation,
} from '../../slices/booksCollectionsApiSlice';
import "react-quill/dist/quill.snow.css";


const BooksCollectionEditScreen = () => {
  const { id: booksCollectionId } = useParams();

  const navigate = useNavigate();
    
  const [name, setName] = useState('');
  const [intention, setIntention] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [inList, setInList] = useState(true);

  const { data: booksCollection, isLoading, error } = useGetBooksCollectionDetailsByIdQuery({
    booksCollectionId,
    isAdminSpace: true,
  });
  

  const [updateBooksCollection, { isLoading: loadingUpdate }] = useUpdateBooksCollectionMutation();


  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateBooksCollection({
        booksCollectionId,
        name,
        intention,
        isVisible,
        inList,
      }).unwrap();
      toast.success('Fiche mise à jour avec succès');
      navigate('/admin/bookscollectionlist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };
  

  useEffect(() => {
    if (booksCollection) {
      setName(booksCollection.name);
      setIntention(booksCollection.intention || '');
      setIsVisible(booksCollection.isVisible);
    }
  }, [booksCollection]);

  return (
    <Container>
      <FormContainer>
        <div className="h1-adminContainer">
          <h1>Modifier la collection</h1>
        </div>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error.data.message}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
          
            <Form.Group controlId='name'>
              <Form.Label>Nom de la collection</Form.Label>
              <Form.Control
                type='text'
                placeholder='Saisir le nom'
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>
  
            <Form.Group controlId='intention'>
              <Form.Label>Intention</Form.Label>
              <ReactQuill value={intention} onChange={setIntention} placeholder="Saisir l'intention" />
            </Form.Group>


            <Form.Group controlId='isVisible'>
              <Form.Label>Visibilité</Form.Label>
              <Form.Check
                type='checkbox'
                label='Visible'
                checked={isVisible}
                onChange={(e) => setIsVisible(e.target.checked)}
              ></Form.Check>
              <Form.Check
                type='checkbox'
                label='Présent dans la liste'
                checked={inList}
                onChange={(e) => setInList(e.target.checked)}
              ></Form.Check>
            </Form.Group>

            <Button
              type='submit'
              variant='primary'
              style={{ marginTop: '1rem' }}
            >
              Mettre à jour
            </Button>
          </Form>
        )}
      </FormContainer>
    </Container>
  );
};

export default BooksCollectionEditScreen;
